
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Watch("data", {
    immediate: true,
  })
  private dataChange() {
    this.filters = JSON.parse(JSON.stringify(this.data));
  }
  private filters: any = {};
  private filterItems: any = [];
  private forceUpdate() {
    this.$forceUpdate();
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.getFilterItems();
    this.filters["研究指标"].push({
      template_id: "心脏无忧筛查",
      result: {},
      selected: {},
      items: this.filterItems,
    });
    this.forceUpdate();
  }
  private getFilterItems() {
    this.filterItems = [
      {
        condition: ["等于", "不等于"],
        id: "2200202",
        origin_type: "文本域",
        origin_value: "",
        template_id: "tem622ededf9e752a037f8daa6c",
        title:
          "请输入内容（建议您下载科大讯飞输入法，通过语音录入患者的病例内容）",
        type: "字符串",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200207",
        origin_type: "单选补充文字",
        origin_value: [
          "隐痛",
          "跳痛",
          "灼痛",
          "刺痛",
          "窜痛",
          "酸痛",
          "无",
          "冷痛",
          "胀痛",
        ],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "颈痛",
        type: "下拉单选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200208",
        origin_type: "单选补充文字",
        origin_value: [
          "隐痛",
          "跳痛",
          "灼痛",
          "刺痛",
          "窜痛",
          "酸痛",
          "无",
          "冷痛",
          "胀痛",
        ],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "头痛",
        type: "下拉单选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200209",
        origin_type: "多选补充文字",
        origin_value: [
          "屈伸不利",
          "侧曲受限",
          "难以支撑",
          "旋转受限",
          "无",
          "广泛僵硬",
        ],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "强直僵硬",
        type: "下拉多选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200210",
        origin_type: "单选",
        origin_value: ["无", "有"],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "酸胀",
        type: "下拉单选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200211",
        origin_type: "单选",
        origin_value: ["无", "有"],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "头晕",
        type: "下拉单选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200212",
        origin_type: "单选",
        origin_value: ["无", "有"],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "头昏",
        type: "下拉单选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200213",
        origin_type: "多选补充文字",
        origin_value: ["痛", "无力", "酸", "无", "木", "麻"],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "上肢症状",
        type: "下拉多选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200214",
        origin_type: "多选补充文字",
        origin_value: ["痛", "无力", "酸", "无", "木", "麻"],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "下肢症状",
        type: "下拉多选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200216",
        origin_type: "单选",
        origin_value: [
          "≤72小时",
          "72小时-3个月",
          "3个月-6个月",
          "6个月-1年",
          "1年-3年",
          "3年-5年",
          "5年-10年",
          "10年以上",
        ],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "病程",
        type: "下拉单选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200217",
        origin_type: "多选补充文字",
        origin_value: [
          "阴雨天",
          "低头",
          "久坐",
          "外伤",
          "劳累",
          "药物",
          "情绪",
          "受寒",
        ],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "发病或加重诱因",
        type: "下拉多选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200218",
        origin_type: "多选补充文字",
        origin_value: [
          "整骨",
          "推拿",
          "理疗",
          "针灸",
          "中药",
          "手术",
          "NSAIDs",
        ],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "治疗史",
        type: "下拉多选",
      },
      {
        condition: ["等于", "不等于"],
        id: "2200219",
        origin_type: "多选补充文字",
        origin_value: [
          "风湿免疫病",
          "消化系统疾病",
          "血液系统疾病",
          "呼吸系统疾病",
          "内分泌系统疾病",
          "无",
          "神经系统疾病",
          "泌尿系统疾病",
          "循环系统疾病",
        ],
        template_id: "tem622ededf9e752a037f8daa6c",
        title: "既往病史",
        type: "下拉多选",
      },
    ];
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["研究指标"].splice(index, 1);
    this.forceUpdate();
  }
  /**
   * @description 重置高级搜索
   */
  private resetPrimarySearch() {
    this.filters.ifPrimarySearched = false;
    this.filters.timeWay = "";
    this.filters.time = [];
    this.filters["条件"] = "";
    this.filters["研究指标"] = [];
  }
  /**
   * @description 确定高级筛选
   */
  private confirmPrimarySearch() {
    this.filters.current_page = 1;
    this.filters.ifPrimarySearched = true;
    this.$emit("change", this.filters);
  }
}
